import {getFirstById} from 'shared/utils/array-utils.fp';
import type {Identified} from 'typings/portaro.be.types';

export default class MediaViewerModel<T extends Identified<any>> {
    private currentItem: T = null;
    private filesArray: T[] = [];

    constructor(public previous: () => any, public next: () => any) {
    }

    public current(): T | null {
        return this.currentItem;
    }

    public files(): T[] {
        return this.filesArray;
    }

    public hasFiles(): boolean {
        return this.filesArray.length > 0;
    }

    public setFiles(arr: T[]) {
        this.filesArray = arr;
    }

    public setCurrentFile(file: T): boolean {
        this.currentItem = file;

        return this.getCurrentIdx() >= 0;
    }

    public unsetCurrent() {
        this.currentItem = null;
    }

    public hasPrevious(): boolean {
        const currentIdx = this.getCurrentIdx();

        return currentIdx !== null && currentIdx > 0;
    }

    public hasNext(): boolean {
        const currentIdx = this.getCurrentIdx();

        return currentIdx !== null && currentIdx < this.filesArray.length - 1;
    }

    public getPrevious(): T {
        if (!this.hasPrevious()) {
            throw new Error('There is not any previous');
        }

        return this.filesArray[this.getCurrentIdx() - 1];
    }

    public getNext(): T {
        if (!this.hasNext()) {
            throw new Error('There is not any next');
        }

        return this.filesArray[this.getCurrentIdx() + 1];
    }

    private getCurrentIdx(): number | null {
        if (!this.currentItem || !this.filesArray) {
            return null;
        }

        const byId = getFirstById<T, keyof T>(this.currentItem.id)(this.filesArray);

        if (!byId) {
            return null;
        }
        return this.filesArray.indexOf(byId);
    }
}
